const defaultProps = {
  elevation: 0,
  color: 'default',
};

export default defaultProps;
